import {Type} from "../redux/Transaction/helper";

export const CustomFieldShow = {
    [Type.sale_quote]: 'sale_quote_show',
    [Type.sale_order]: 'sale_order_show',
    [Type.sale_delivery_order]: 'sale_delivery_order_show',
    [Type.sale_invoice]: 'sale_invoice_show',
    [Type.sale_credit_note]: 'sale_credit_note_show',
    [Type.sale_payment]: 'sale_payment_show',
    [Type.sale_refund]: 'sale_refund_show',
    [Type.purchase_order]: 'purchase_order_show',
    [Type.purchase_goods_received_note]: 'purchase_goods_received_note_show',
    [Type.purchase_bill]: 'purchase_bill_show',
    [Type.purchase_credit_note]: 'purchase_credit_note_show',
    [Type.purchase_payment]: 'purchase_payment_show',
    [Type.purchase_refund]: 'purchase_refund_show',

    [Type.bank_income]: 'bank_income_show',
    [Type.bank_expense]: 'bank_expense_show',
};
